import { AccountObjectApiFacade } from "../account-object/account-object.api-facade";
import { JobStatusSummary } from "./job-status-summary.model";
import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";

export class JobStatusSummaryApiFacade extends AccountObjectApiFacade<JobStatusSummary> {

    get(): Observable<JobStatusSummary> {
        return of(undefined);
    }

    getAll(accountId: string): Observable<Array<JobStatusSummary>> {
        return of([]);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-status-summary-item/job-status-summary.api-facade.ts